<template>
  <div
    v-if="isMobileLandscape"
    class="type-h3 fixed inset-0 z-1000 flex items-center justify-center bg-[rgba(255,255,255,0.33)] text-center text-black backdrop-blur-[2px]"
    @click="isMobileLandscape = false"
  >
    <div class="flex flex-col p-6 font-medium">
      <span>{{ t('navigation.mobileOrientation.title') }}</span>
      <ArrowPathIcon class="mx-auto my-3 w-8" />
      <span class="text-txt-700">{{ t('navigation.mobileOrientation.dismiss') }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import i18n from '@/plugins/vue-i18n.js';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';

const { t } = i18n.global;

const isMobileLandscape = ref(false);

const checkOrientation = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;

  isMobileLandscape.value = width > height && width < 1024;
};

onMounted(() => {
  window.addEventListener('resize', checkOrientation);
  checkOrientation();
});

onUnmounted(() => {
  window.removeEventListener('resize', checkOrientation);
});
</script>

<style scoped>
@media screen and (orientation: landscape) {
  body {
    overflow: hidden;
  }
}
</style>
